import React, { useEffect } from 'react';
import { FiArrowLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-brand-dark min-h-screen text-white">
      <SEO 
        title="Privacy Policy - Christian Videos"
        description="Read our Privacy Policy to understand how we collect, use, and protect your personal information."
        url="https://christianvideos.in/privacy-policy"
      />
      {/* Back Button */}
      <div className="p-4 sm:p-6 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 hover:text-gray-300 transition-colors text-sm sm:text-base"
        >
          <FiArrowLeft size={20} className="sm:w-6 sm:h-6" />
          <span>Back</span>
        </button>
      </div>

      {/* Content */}
      <div className="px-4 sm:px-6 md:px-8 lg:pl-20 lg:pr-8 py-8 sm:py-12 max-w-4xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-2 text-gradient-accent">
          Privacy Policy
        </h1>
        <p className="text-gray-400 mb-8">Last updated: November 2025</p>

        <div className="space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">1. Introduction</h2>
            <p>
              Christian Videos ("we," "us," "our," or "Company") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information when 
              you visit our website and use our services.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">2. Information We Collect</h2>
            <div className="space-y-3">
              <h3 className="font-semibold text-white">Information You Provide Directly:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Search queries and viewing history</li>
                <li>Watchlist and saved preferences</li>
                <li>Comments and feedback (if applicable)</li>
              </ul>
            </div>
            <div className="space-y-3 mt-4">
              <h3 className="font-semibold text-white">Information Collected Automatically:</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Browser type and IP address</li>
                <li>Pages visited and time spent on site</li>
                <li>Referral sources and device information</li>
                <li>Cookie and analytics data</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide and improve our services</li>
              <li>To personalize your viewing experience</li>
              <li>To analyze usage patterns and trends</li>
              <li>To comply with legal obligations</li>
              <li>To respond to your inquiries</li>
              <li>To prevent fraud and abuse</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">4. Google Analytics</h2>
            <p>
              We use Google Analytics to understand how users interact with our platform. This helps us improve 
              our services and user experience. Google Analytics collects information about your browsing behavior 
              and may set cookies on your device. For more information about Google's privacy practices, please 
              visit the Google Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">5. Cookies and Tracking</h2>
            <p>
              We use cookies to enhance your experience on our platform. Cookies help us remember your preferences, 
              understand user behavior, and improve our services. You can control cookie settings through your 
              browser preferences.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">6. Third-Party Services</h2>
            <p>
              Our platform integrates YouTube for video playback. Please review YouTube's Privacy Policy for 
              information about how they handle your data. We do not share your personal information with third 
              parties without your consent, except as required by law.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">7. Your Rights</h2>
            <p>
              Depending on your location, you may have certain rights regarding your personal information, 
              including the right to access, correct, or delete your data. Please contact us to exercise 
              these rights.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">8. Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your information against 
              unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over 
              the Internet is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">9. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our privacy practices, please contact us at 
              support@christianvideos.in or visit https://christianvideos.in/contact-us.
            </p>
          </section>

          <section className="bg-gray-800 p-6 rounded-lg">
            <h2 className="text-xl sm:text-2xl font-semibold mb-3 text-white">10. Policy Changes</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any significant changes 
              by posting the new policy on this page and updating the "Last updated" date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
